'use strict';

module.exports = /* @ngInject */ function ($resource, apiConfig) {

	return {
		error: function(msg) {
			growl(msg.data.error, 1);
		},
		treeLevel: $resource(
					apiConfig.$get().apiUrl + '/classifycode/tree/level',
					{
						codedName:'@codedName',
						classificationId:'@classificationId'
					}
				),
		accounts: $resource(
			apiConfig.$get().apiUrl + '/account/user'
		)
	};
}
